import Axios from 'axios'

const BASE_URL_END_POINT = '/discounts'

export const saveDiscounts = async (file) => {
  const formData = new FormData()
  formData.append('discounts', file, file.name)
  const response = await Axios.post(`${BASE_URL_END_POINT}/updateDiscountsFromFile`, formData, {
    timeout: 300000, // 5 minutes to upload (80k rows)
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

export const getClientDiscounts = async (clientCode, filters = {}) => {
  // Build query parameters from filters
  const queryParams = new URLSearchParams()

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      // Convert to string and trim if it's a string, otherwise just convert to string
      const stringValue = typeof value === 'string' ? value.trim() : String(value)
      if (stringValue) {
        queryParams.append(key, stringValue)
      }
    }
  })

  const queryString = queryParams.toString()
  const url = queryString
    ? `${BASE_URL_END_POINT}/${clientCode}?${queryString}`
    : `${BASE_URL_END_POINT}/${clientCode}`

  const response = await Axios.get(url)
  return response.data
}

export const submitDiscountRequest = async (payload) => {
  const response = await Axios.post(`${BASE_URL_END_POINT}/request`, payload)
  return response.data
}

export const getAvailableTargets = async (clientCode, type) => {
  const queryParams = new URLSearchParams({
    clientCode,
    type,
  })

  const response = await Axios.get(`${BASE_URL_END_POINT}/getAvailableTargets?${queryParams}`)
  return response.data
}
